import EntityManageView from 'Components/EntityManageView';
import { actions } from 'ducks/users';
import React from 'react';
import { useSelector } from 'react-redux';
import validators from 'utils/forms/validators';

const formSchema = [
    {
        type: 'text',
        label: 'Name\x2a',
        name: 'name',
        validate: [validators.required]
    },
    {
        type: 'text',
        label: 'Email\x2a',
        name: 'email',
        validate: [validators.required]
    },
    {
        type: 'checkBox',
        label: 'Enabled?',
        name: 'enabled'
    }
];

const Component = props => {
    const { update } = props;

    const model = useSelector(state => state.users.models[state.drawerView.entityId]);
    const submitting = useSelector(state => state.users.submitting);
    const stateProps = { model, submitting };

    const { useUpdate } = actions;
    const actionProps = {
        update: useUpdate()
    };

    return (
        <EntityManageView
            formInitialValues={model}
            formSchema={formSchema}
            label="Edit User"
            submitting={submitting}
            update={update}
            {...stateProps}
            {...actionProps}
        />
    );
};

export default Component;
